module.exports = __webpack_public_path__ + "static/25-Changes-e796ba17b7b1b7d09b93287d1724ebc2.png";